import { Component, Input, OnInit } from '@angular/core';
import { SbModalState } from '../modal-state.service';
import { ErrorOptions } from '../modal.model';

@Component({
  selector: 'sb-forbidden-modal',
  templateUrl: './sb-forbidden-modal.component.html',
  styleUrls: ['./sb-forbidden-modal.component.scss'],
  standalone: false,
})
export class SbForbiddenModalComponent implements OnInit {
  options: ErrorOptions<any>;
  @Input()
  templateId: string;

  ngOnInit() {
    this.options = this.state.options.get(this.templateId) as ErrorOptions<any>;
  }

  constructor(private state: SbModalState) {}

  ok() {
    this.state.modals.get(this.templateId).close('OK');
  }
}
